




























































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import ServiceLogSliderSelector from "@/components/payroll/business/services/service/ServiceLogSliderSelector.vue";
import RefContactSliderSelector from "@/components/payroll/business/services/contact/RefContactSliderSelector.vue";
import {
	CreateInvoicePayload,
	InvoiceContact, SelectableServiceLogDTO, ServiceInvoice,
	ServiceRecordDTO, UpdateDraftInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import SelectOption from "@/components/common/SelectOption";
import Notifications from "@/state/Notifications";
import Application from "@/state/Application";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";

@Component({
	components: {RefContactSliderSelector, ServiceLogSliderSelector, PortalSelect, ServiceLogView, RightSideBar}
})
export default class DraftInvoicePreparer extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	@Prop()
	private getInvoice!: () => ServiceInvoice | null

	get invoice(): ServiceInvoice | null {
		return this.getInvoice();
	}

	private req = new UpdateDraftInvoicePayload()

	private selectedContact: InvoiceContact | null = null;
	private selectedServices: Array<SelectableServiceLogDTO> = [];

	drop(log: SelectableServiceLogDTO) {
		log.selected = false
		this.selectedServices = this.selectedServices.filter(l => l.id !== log.id)
	}

	mount(visible: boolean) {
		if (visible) {
			this.selectedServices = this.invoice!.logs.map(it => new SelectableServiceLogDTO(it))
			this.selectedServices.forEach(it => it.selected = true)
		} else {
			this.selectedServices = []
		}
	}

	private createService = false;

	private selected(arr: Array<SelectableServiceLogDTO> | null) {
		if (arr == null) return
		arr.filter(log => this.selectedServices.find(it => it.id != log.id)).forEach(it => this.selectedServices.push(it))
	}

	get dueDayOptions(): SelectOption[] {
		return [
			SelectOption.builder().title("7 days").value(7).build(),
			SelectOption.builder().title("14 days").value(14).build(),
			SelectOption.builder().title("30 days").value(30).build()
		]
	}

	draft() {
		if (this.selectedServices == null || this.selectedServices.length == 0) {
			Notifications.error("Please select services")
			return;
		}
		Application.startLoading()
		this.req.id = this.invoice!.id
		this.req.serviceLogs = this.selectedServices.map(it => it.id)
		this.req.payerId = this.invoice!.payer.id
		this.req.status = "DRAFT"
		ServiceInvoiceOrchestrator.updateDraftInvoice(this.req).then(
			() => {
				Application.stopLoading()
				this.$emit("create")
				this.$emit("input", false)
			},
			err => processError(err, this)
		)
	}

	create() {
		if (this.selectedServices && this.selectedServices.length == 0) {
			Notifications.error("Please select services")
			return
		}
		Application.startLoading()
		this.req.id = this.invoice!.id
		this.req.status = "IN_PROGRESS"
		this.req.payerId = this.invoice!.payer.id
		this.req.serviceLogs = this.selectedServices.map(it => it.id)
		ServiceInvoiceOrchestrator.updateDraftInvoice(this.req).then(
			() => {
				Application.stopLoading()
				this.$emit("create")
				this.$emit("input", false)
			},
			err => processError(err, this)
		)
	}

	get total(): string {
		let total = 0;
		this.selectedServices.map(it => it.total).forEach(it => total += it)
		return "$" + total.toLocaleString("en-US")
	}

}
